import { render } from "./TextToolbar.vue?vue&type=template&id=4e0cdd32&scoped=true&ts=true"
import script from "./TextToolbar.vue?vue&type=script&lang=ts"
export * from "./TextToolbar.vue?vue&type=script&lang=ts"

import "./TextToolbar.vue?vue&type=style&index=0&id=4e0cdd32&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0cdd32"]])

export default __exports__